export const banners = {
  beginners: [
    {
      name: "Beginners' Wish",
      shortName: "Beginners' Wish",
      image: 1,
      start: '2000-01-01 00:00:00',
      end: '2200-01-01 00:00:00',
      color: '#FFFFFF',
    },
  ],
  standard: [
    {
      name: 'Wanderlust Invocation',
      shortName: 'Wanderlust Invocation',
      image: 1,
      start: '2000-01-01 00:00:00',
      end: '2200-01-01 00:00:00',
      color: '#FFFFFF',
    },
  ],
  characters: [
    {
      name: 'Ballad in Goblets',
      image: 1,
      shortName: 'Venti',
      start: '2020-09-28 00:00:00',
      end: '2020-10-18 18:00:00',
      color: '#55E4B0',
      timezoneDependent: true,
      featured: ['venti'],
      featuredRare: ['barbara', 'fischl', 'xiangling'],
      version: '1.0',
    },
    {
      name: 'Sparkling Steps',
      image: 1,
      shortName: 'Klee',
      start: '2020-10-20 18:00:00',
      end: '2020-11-10 16:00:00',
      color: '#CA360E',
      featured: ['klee'],
      featuredRare: ['xingqiu', 'sucrose', 'noelle'],
      version: '1.0',
    },
    {
      name: 'Farewell of Snezhnaya',
      image: 1,
      shortName: 'Tartaglia',
      start: '2020-11-11 06:00:00',
      end: '2020-12-01 16:00:00',
      color: '#50A3C0',
      timezoneDependent: true,
      featured: ['tartaglia'],
      featuredRare: ['ningguang', 'beidou', 'diona'],
      version: '1.1',
    },
    {
      name: 'Gentry of Hermitage',
      image: 1,
      shortName: 'Zhongli',
      start: '2020-12-01 18:00:00',
      end: '2020-12-22 15:00:00',
      color: '#D1A55C',
      featured: ['zhongli'],
      featuredRare: ['xinyan', 'razor', 'chongyun'],
      version: '1.1',
    },
    {
      name: 'Secretum Secretorum',
      image: 1,
      shortName: 'Albedo',
      start: '2020-12-23 06:00:00',
      end: '2021-01-12 16:00:00',
      color: '#FCFE83',
      timezoneDependent: true,
      featured: ['albedo'],
      featuredRare: ['fischl', 'bennett', 'sucrose'],
      version: '1.2',
    },
    {
      name: 'Adrift in the Harbor',
      image: 1,
      shortName: 'Ganyu',
      start: '2021-01-12 18:00:00',
      end: '2021-02-02 15:00:00',
      color: '#6994DF',
      featured: ['ganyu'],
      featuredRare: ['xingqiu', 'xiangling', 'noelle'],
      version: '1.2',
    },
    {
      name: 'Invitation to Mundane Life',
      image: 1,
      shortName: 'Xiao',
      start: '2021-02-03 06:00:00',
      end: '2021-02-17 16:00:00',
      color: '#25d7b8',
      timezoneDependent: true,
      featured: ['xiao'],
      featuredRare: ['diona', 'xinyan', 'beidou'],
      version: '1.3',
    },
    {
      name: 'Dance of Lanterns',
      image: 1,
      shortName: 'Keqing',
      start: '2021-02-17 18:00:00',
      end: '2021-03-02 16:00:00',
      color: '#AB6CD7',
      featured: ['keqing'],
      featuredRare: ['barbara', 'bennett', 'ningguang'],
      version: '1.3',
    },
    {
      name: 'Moment of Bloom',
      image: 1,
      shortName: 'Hu Tao',
      start: '2021-03-02 18:00:00',
      end: '2021-03-16 15:00:00',
      color: '#BF5042',
      featured: ['hu_tao'],
      featuredRare: ['xingqiu', 'xiangling', 'chongyun'],
      version: '1.3',
    },
    {
      name: 'Ballad in Goblets',
      image: 2,
      shortName: 'Venti',
      start: '2021-03-17 06:00:00',
      end: '2021-04-06 16:00:00',
      color: '#35C297',
      featured: ['venti'],
      featuredRare: ['sucrose', 'razor', 'noelle'],
      timezoneDependent: true,
      version: '1.4',
    },
    {
      name: 'Farewell of Snezhnaya',
      image: 2,
      shortName: 'Tartaglia',
      start: '2021-04-06 18:00:00',
      end: '2021-04-27 15:00:00',
      color: '#50A3C0',
      featured: ['tartaglia'],
      featuredRare: ['rosaria', 'fischl', 'barbara'],
      version: '1.4',
    },
    {
      name: 'Gentry of Hermitage',
      image: 2,
      shortName: 'Zhongli',
      start: '2021-04-28 06:00:00',
      end: '2021-05-18 17:59:59',
      color: '#D1A55C',
      featured: ['zhongli'],
      featuredRare: ['yanfei', 'noelle', 'diona'],
      timezoneDependent: true,
      version: '1.5',
    },
    {
      name: 'Born of Ocean Swell',
      image: 1,
      shortName: 'Eula',
      start: '2021-05-18 18:00:00',
      end: '2021-06-08 15:00:00',
      color: '#A6D6E0',
      featured: ['eula'],
      featuredRare: ['xingqiu', 'beidou', 'xinyan'],
      version: '1.5',
    },
    {
      name: 'Sparkling Steps',
      image: 2,
      shortName: 'Klee',
      start: '2021-06-09 06:00:00',
      end: '2021-06-29 17:59:59',
      color: '#CA360E',
      featured: ['klee'],
      featuredRare: ['fischl', 'sucrose', 'barbara'],
      timezoneDependent: true,
      version: '1.6',
    },
    {
      name: 'Leaves in the Wind',
      image: 1,
      shortName: 'Kazuha',
      start: '2021-06-29 18:00:00',
      end: '2021-07-20 14:59:59',
      color: '#8FFFDE',
      featured: ['kaedehara_kazuha'],
      featuredRare: ['bennett', 'razor', 'rosaria'],
      version: '1.6',
    },
    {
      name: 'The Herons Court',
      image: 1,
      shortName: 'Ayaka',
      start: '2021-07-21 06:00:00',
      end: '2021-08-10 17:59:59',
      color: '#FFFBF7',
      featured: ['kamisato_ayaka'],
      featuredRare: ['chongyun', 'ningguang', 'yanfei'],
      timezoneDependent: true,
      version: '2.0',
    },
    {
      name: 'Tapestry of Golden Flames',
      image: 1,
      shortName: 'Yoimiya',
      start: '2021-08-10 18:00:00',
      end: '2021-08-31 14:59:59',
      color: '#F7D69F',
      featured: ['yoimiya'],
      featuredRare: ['sayu', 'diona', 'xinyan'],
      version: '2.0',
    },
    {
      name: 'Reign of Serenity',
      image: 1,
      shortName: 'Raiden',
      start: '2021-09-01 06:00:00',
      end: '2021-09-21 17:59:59',
      color: '#D0AEF2',
      featured: ['raiden_shogun'],
      featuredRare: ['xiangling', 'sucrose', 'kujou_sara'],
      timezoneDependent: true,
      version: '2.1',
    },
    {
      name: 'Drifting Luminescence',
      image: 1,
      shortName: 'Kokomi',
      start: '2021-09-21 18:00:00',
      end: '2021-10-12 14:59:59',
      color: '#FF7B69',
      featured: ['sangonomiya_kokomi'],
      featuredRare: ['rosaria', 'beidou', 'xingqiu'],
      version: '2.1',
    },
    {
      name: 'Farewell of Snezhnaya',
      image: 3,
      shortName: 'Tartaglia',
      start: '2021-10-13 06:00:00',
      end: '2021-11-02 17:59:59',
      color: '#4ED8F3',
      featured: ['tartaglia'],
      featuredRare: ['ningguang', 'chongyun', 'yanfei'],
      timezoneDependent: true,
      version: '2.2',
    },
    {
      name: 'Moment of Bloom',
      image: 2,
      shortName: 'Hu Tao',
      start: '2021-11-02 18:00:00',
      end: '2021-11-23 14:59:59',
      color: '#FF7966',
      featured: ['hu_tao'],
      featuredRare: ['thoma', 'diona', 'sayu'],
      version: '2.2',
    },
    {
      name: 'Secretum Secretorum',
      image: 2,
      shortName: 'Albedo',
      start: '2021-11-24 06:00:00',
      end: '2021-12-14 17:59:59',
      color: '#FFFAF5',
      featured: ['albedo', 'eula'],
      featuredRare: ['rosaria', 'noelle', 'bennett'],
      timezoneDependent: true,
      version: '2.3',
    },
    // {
    //   name: 'Born of Ocean Swell',
    //   image: 2,
    //   shortName: 'Eula',
    //   start: '2021-11-24 06:00:00',
    //   end: '2021-12-14 17:59:59',
    //   color: '#E7F9FF',
    //   featured: ['eula'],
    //   featuredRare: ['rosaria', 'noelle', 'bennett'],
    //   timezoneDependent: true,
    //   version: '2.3'
    // },
    {
      name: "Oni's Royale",
      image: 1,
      shortName: 'Itto',
      start: '2021-12-14 18:00:00',
      end: '2022-01-04 17:59:59',
      color: '#FFB455',
      featured: ['arataki_itto'],
      featuredRare: ['gorou', 'xiangling', 'barbara'],
      version: '2.3',
    },
    {
      name: 'The Transcendent One Returns',
      image: 1,
      shortName: 'Shenhe',
      start: '2022-01-05 06:00:00',
      end: '2022-01-25 17:59:59',
      color: '#81DDF0',
      featured: ['shenhe', 'xiao'],
      featuredRare: ['yun_jin', 'ningguang', 'chongyun'],
      timezoneDependent: true,
      version: '2.4',
    },
    // {
    //   name: 'Invitation to Mundane Life',
    //   image: 2,
    //   shortName: 'Xiao',
    //   start: '2022-01-05 06:00:00',
    //   end: '2022-01-25 17:59:59',
    //   color: '#25d7b8',
    //   featured: ['shenhe', 'xiao'],
    //   featuredRare: ['yun_jin', 'ningguang', 'chongyun'],
    //   timezoneDependent: true,
    //   version: '2.4'
    // },
    {
      name: 'Gentry of Hermitage',
      image: 3,
      shortName: 'Zhongli',
      start: '2022-01-25 18:00:00',
      end: '2022-02-15 14:59:59',
      color: '#FFF5BF',
      featured: ['zhongli', 'ganyu'],
      featuredRare: ['xingqiu', 'beidou', 'yanfei'],
      version: '2.4',
    },
    // {
    //   name: 'Adrift in the Harbor',
    //   image: 2,
    //   shortName: 'Ganyu',
    //   start: '2022-01-25 18:00:00',
    //   end: '2022-02-15 14:59:59',
    //   color: '#FFF5BF',
    //   featured: ['zhongli', 'ganyu'],
    //   featuredRare: ['xingqiu', 'beidou', 'yanfei'],
    // },
    {
      name: 'Everbloom Violet',
      image: 1,
      shortName: 'Yae',
      start: '2022-02-16 06:00:00',
      end: '2022-03-08 17:59:59',
      color: '#ffd1f9',
      featured: ['yae_miko'],
      featuredRare: ['thoma', 'diona', 'fischl'],
      timezoneDependent: true,
      version: '2.5',
    },
    {
      name: 'Reign of Serenity',
      image: 2,
      shortName: 'Raiden',
      start: '2022-03-08 18:00:00',
      end: '2022-03-29 14:59:59',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'sangonomiya_kokomi'],
      featuredRare: ['bennett', 'xinyan', 'kujou_sara'],
      version: '2.5',
    },
    // {
    //   name: 'Drifting Luminescence',
    //   image: 2,
    //   shortName: 'Kokomi',
    //   start: '2022-03-08 18:00:00',
    //   end: '2022-03-29 14:59:59',
    //   color: '#53caf3',
    //   featured: ['raiden_shogun', 'sangonomiya_kokomi'],
    //   featuredRare: ['bennett', 'xinyan', 'kujou_sara'],
    //   version: '2.5'
    // },
    {
      name: 'Azure Excursion',
      image: 1,
      shortName: 'Ayato',
      start: '2022-03-30 06:00:00',
      end: '2022-04-19 17:59:59',
      color: '#90bce9',
      featured: ['kamisato_ayato', 'venti'],
      featuredRare: ['yun_jin', 'xiangling', 'sucrose'],
      timezoneDependent: true,
      version: '2.6',
    },
    // {
    //   name: 'Ballad in Goblets',
    //   image: 3,
    //   shortName: 'Venti',
    //   start: '2022-03-30 06:00:00',
    //   end: '2022-04-19 17:59:59',
    //   color: '#ffd1f9',
    //   featured: ['kamisato_ayato', 'venti'],
    //   featuredRare: ['yun_jin', 'xiangling', 'sucrose'],
    //   timezoneDependent: true,
    //   version: '2.6'
    // },
    {
      name: 'The Herons Court',
      image: 2,
      shortName: 'Ayaka',
      start: '2022-04-19 18:00:00',
      end: '2022-05-31 05:59:59',
      color: '#FFFBF7',
      featured: ['kamisato_ayaka'],
      featuredRare: ['sayu', 'razor', 'rosaria'],
      timezoneDependentEnd: true,
      version: '2.6',
    },
    {
      name: 'Discerner of Enigmas',
      image: 1,
      shortName: 'Yelan',
      start: '2022-05-31 09:00:00',
      end: '2022-06-21 17:59:59',
      color: '#7de6fd',
      featured: ['yelan', 'xiao'],
      featuredRare: ['barbara', 'noelle', 'yanfei'],
      timezoneDependent: true,
      version: '2.7',
    },
    // {
    //   name: 'Invitation to Mundane Life',
    //   image: 3,
    //   shortName: 'Xiao',
    //   start: '2022-05-31 06:00:00',
    //   end: '2022-06-21 17:59:59',
    //   color: '#25d7b8',
    //   featured: ['yelan', 'xiao'],
    //   featuredRare: ['barbara', 'noelle', 'yanfei'],
    //   timezoneDependent: true,
    // },
    {
      name: "Oni's Royale",
      image: 2,
      shortName: 'Itto',
      start: '2022-06-21 18:00:00',
      end: '2022-07-12 14:59:59',
      color: '#FFB455',
      featured: ['arataki_itto'],
      featuredRare: ['chongyun', 'gorou', 'kuki_shinobu'],
      version: '2.7',
    },
    {
      name: 'Leaves in the Wind',
      image: 2,
      shortName: 'Kazuha',
      start: '2022-07-13 06:00:00',
      end: '2022-08-02 17:59:59',
      color: '#7edec3',
      featured: ['kaedehara_kazuha', 'klee'],
      featuredRare: ['ningguang', 'thoma', 'shikanoin_heizou'],
      timezoneDependent: true,
      version: '2.8',
    },
    // {
    //   name: "Sparkling Steps",
    //   image: 3,
    //   shortName: 'Klee',
    //   start: '2022-07-13 06:00:00',
    //   end: '2022-08-02 17:59:59',
    //   color: '#ff7763',
    //   featured: ['kaedehara_kazuha', 'klee'],
    //   featuredRare: ['ningguang', 'thoma', 'shikanoin_heizou'],
    //   timezoneDependent: true,
    //   version: '2.8'
    // },
    {
      name: 'Tapestry of Golden Flames',
      image: 2,
      shortName: 'Yoimiya',
      start: '2022-08-02 18:00:00',
      end: '2022-08-23 14:59:59',
      color: '#fc8976',
      featured: ['yoimiya'],
      featuredRare: ['yun_jin', 'xinyan', 'bennett'],
      version: '2.8',
    },
    {
      name: 'Viridescent Vigil',
      image: 1,
      shortName: 'Tighnari',
      start: '2022-08-24 06:00:00',
      end: '2022-09-09 17:59:59',
      color: '#76df81',
      featured: ['tighnari', 'zhongli'],
      featuredRare: ['collei', 'fischl', 'diona'],
      timezoneDependent: true,
      version: '3.0',
    },
    // {
    //   name: 'Gentry of Hermitage',
    //   image: 4,
    //   shortName: 'Zhongli',
    //   start: '2022-08-24 06:00:00',
    //   end: '2022-09-09 17:59:59',
    //   color: '#D1A55C',
    //   featured: ['tighnari', 'zhongli'],
    //   featuredRare: ['collei', 'fischl', 'diona'],
    //   timezoneDependent: true,
    //   version: '3.0'
    // },
    {
      name: 'Adrift in the Harbor',
      image: 3,
      shortName: 'Ganyu',
      start: '2022-09-09 18:00:00',
      end: '2022-09-27 14:59:59',
      color: '#ceebf3',
      featured: ['ganyu', 'sangonomiya_kokomi'],
      featuredRare: ['xingqiu', 'sucrose', 'dori'],
      version: '3.0',
    },
    // {
    //   name: 'Drifting Luminescence',
    //   image: 3,
    //   shortName: 'Kokomi',
    //   start: '2022-09-09 18:00:00',
    //   end: '2022-09-27 14:59:59',
    //   color: '#ceebf3',
    //   featured: ['ganyu', 'sangonomiya_kokomi'],
    //   featuredRare: ['xingqiu', 'sucrose', 'dori'],
    //   version: '3.0',
    // },
    {
      name: 'Twilight Arbiter',
      image: 1,
      shortName: 'Cyno',
      start: '2022-09-28 06:00:00',
      end: '2022-10-14 17:59:59',
      color: '#d8b8f7',
      featured: ['cyno', 'venti'],
      featuredRare: ['sayu', 'candace', 'kuki_shinobu'],
      timezoneDependent: true,
      version: '3.1',
    },
    // {
    //   name: 'Ballad in Goblets',
    //   image: 4,
    //   shortName: 'Venti',
    //   start: '2022-09-28 06:00:00',
    //   end: '2022-10-14 17:59:59',
    //   color: '#96f6de',
    //   featured: ['cyno', 'venti'],
    //   featuredRare: ['sayu', 'candace', 'kuki_shinobu'],
    //   timezoneDependent: true,
    //   version: '3.1',
    // },
    {
      name: 'Twirling Lotus',
      image: 1,
      shortName: 'Nilou',
      start: '2022-10-14 18:00:00',
      end: '2022-11-01 14:59:59',
      color: '#b2e0f0',
      featured: ['nilou', 'albedo'],
      featuredRare: ['barbara', 'xiangling', 'beidou'],
      version: '3.1',
    },
    // {
    //   name: 'Secretum Secretorum',
    //   image: 3,
    //   shortName: 'Nilou',
    //   start: '2022-10-14 18:00:00',
    //   end: '2022-11-01 14:59:59',
    //   color: '#b2e0f0',
    //   featured: ['nilou', 'albedo'],
    //   featuredRare: ['barbara', 'xiangling', 'beidou'],
    //   version: '3.1',
    // },
    {
      name: "The Moongrass' Enlightenment",
      image: 1,
      shortName: 'Nahida',
      start: '2022-11-02 06:00:00',
      end: '2022-11-18 17:59:59',
      color: '#d8b8f7',
      featured: ['nahida', 'yoimiya'],
      featuredRare: ['bennett', 'razor', 'noelle'],
      timezoneDependent: true,
      version: '3.2',
    },
    // {
    //   name: "Tapestry of Golden Flames",
    //   image: 3,
    //   shortName: 'Yoimiya',
    //   start: '2022-11-02 06:00:00',
    //   end: '2022-11-18 17:59:59',
    //   color: '#fc8976',
    //   featured: ['nahida', 'yoimiya'],
    //   featuredRare: ['bennett', 'razor', 'noelle'],
    //   timezoneDependent: true,
    //   version: '3.2',
    // },
    {
      name: 'Everbloom Violet',
      image: 2,
      shortName: 'Yae Miko',
      start: '2022-11-18 18:00:00',
      end: '2022-12-06 14:59:59',
      color: '#ffd1f9',
      featured: ['yae_miko', 'tartaglia'],
      featuredRare: ['thoma', 'shikanoin_heizou', 'layla'],
      version: '3.2',
    },
    // {
    //   name: "Farewell of Snezhnaya",
    //   image: 4,
    //   shortName: 'Tartaglia',
    //   start: '2022-11-18 18:00:00',
    //   end: '2022-12-06 14:59:59',
    //   color: '#4ED8F3',
    //   featured: ['yae_miko', 'tartaglia'],
    //   featuredRare: ['thoma', 'shikanoin_heizou', 'layla'],
    //   version: '3.2',
    // },
    {
      name: 'From Ashes Reborn',
      image: 1,
      shortName: 'Wanderer',
      start: '2022-12-07 06:00:00',
      end: '2022-12-27 17:59:59',
      color: '#31cae1',
      featured: ['wanderer', 'arataki_itto'],
      featuredRare: ['faruzan', 'yanfei', 'gorou'],
      timezoneDependent: true,
      version: '3.3',
    },
    // {
    //   name: "Oni's Royale",
    //   image: 3,
    //   shortName: 'Itto',
    //   start: '2022-12-07 06:00:00',
    //   end: '2022-12-27 17:59:59',
    //   color: '#FFB455',
    //   featured: ['wanderer', 'arataki_itto'],
    //   featuredRare: ['faruzan', 'yanfei', 'gorou'],
    //   timezoneDependent: true,
    //   version: '3.3',
    // },
    {
      name: 'Reign of Serenity',
      image: 3,
      shortName: 'Raiden',
      start: '2022-12-27 18:00:00',
      end: '2023-01-17 14:59:59',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'kamisato_ayato'],
      featuredRare: ['sayu', 'rosaria', 'kujou_sara'],
      version: '3.3',
    },
    // {
    //   name: 'Azure Excursion',
    //   image: 2,
    //   shortName: 'Ayato',
    //   start: '2022-12-27 18:00:00',
    //   end: '2023-01-17 14:59:59',
    //   color: '#90bce9',
    //   featured: ['raiden_shogun', 'kamisato_ayato'],
    //   featuredRare: ['sayu', 'rosaria', 'kujou_sara'],
    //   version: '3.3',
    // },
    {
      name: 'Caution in Confidence',
      image: 1,
      shortName: 'Alhaitham',
      start: '2023-01-18 06:00:00',
      end: '2023-02-07 17:59:59',
      color: '#5bcbd1',
      featured: ['alhaitham', 'xiao'],
      featuredRare: ['xinyan', 'yun_jin', 'yaoyao'],
      timezoneDependent: true,
      version: '3.4',
    },
    // {
    //   name: 'Invitation to Mundane Life',
    //   image: 4,
    //   shortName: 'Xiao',
    //   start: '2023-01-18 06:00:00',
    //   end: '2023-02-07 17:59:59',
    //   color: '#25d7b8',
    //   featured: ['alhaitham', 'xiao'],
    //   featuredRare: ['xinyan', 'yun_jin', 'yaoyao'],
    //   timezoneDependent: true,
    //   version: '3.4',
    // },
    {
      name: 'Moment of Bloom',
      image: 3,
      shortName: 'Hu Tao',
      start: '2023-02-07 18:00:00',
      end: '2023-02-28 14:59:59',
      color: '#FF7966',
      featured: ['hu_tao', 'yelan'],
      featuredRare: ['beidou', 'ningguang', 'xingqiu'],
      version: '3.4',
    },
    // {
    //   name: 'Discerner of Enigmas',
    //   image: 2,
    //   shortName: 'Yelan',
    //   start: '2023-02-07 18:00:00',
    //   end: '2023-02-28 14:59:59',
    //   color: '#7de6fd',
    //   featured: ['hu_tao', 'yelan'],
    //   featuredRare: ['beidou', 'ningguang', 'xingqiu'],
    //   version: '3.4',
    // },
    {
      name: 'Auric Blaze',
      image: 1,
      shortName: 'Dehya',
      start: '2023-03-01 06:00:00',
      end: '2023-03-21 17:59:59',
      color: '#FF7966',
      featured: ['dehya', 'cyno'],
      featuredRare: ['bennett', 'collei', 'barbara'],
      timezoneDependent: true,
      version: '3.5',
    },
    // {
    //   name: 'Twilight Arbiter',
    //   image: 2,
    //   shortName: 'Cyno',
    //   start: '2023-03-01 06:00:00',
    //   end: '2023-03-21 17:59:59',
    //   color: '#FF7966',
    //   featured: ['dehya', 'cyno'],
    //   featuredRare: ['bennett', 'collei', 'barbara'],
    //   timezoneDependent: true,
    //   version: '3.5',
    // },
    {
      name: 'The Transcendent One Returns',
      image: 2,
      shortName: 'Shenhe',
      start: '2023-03-21 18:00:00',
      end: '2023-04-11 14:59:59',
      color: '#81DDF0',
      featured: ['shenhe', 'kamisato_ayaka'],
      featuredRare: ['diona', 'sucrose', 'mika'],
      version: '3.5',
    },
    // {
    //   name: 'The Herons Court',
    //   image: 3,
    //   shortName: 'Shenhe',
    //   start: '2023-03-21 18:00:00',
    //   end: '2023-04-11 14:59:59',
    //   color: '#FFFBF7',
    //   featured: ['shenhe', 'kamisato_ayaka'],
    //   featuredRare: ['diona', 'sucrose', 'mika'],
    //   version: '3.5',
    // },
    {
      name: "The Moongrass' Enlightenment",
      image: 2,
      shortName: 'Nahida',
      start: '2023-04-12 06:00:00',
      end: '2023-05-02 17:59:59',
      color: '#b8db94',
      featured: ['nahida', 'nilou'],
      featuredRare: ['kuki_shinobu', 'dori', 'layla'],
      timezoneDependent: true,
      version: '3.6',
    },
    // {
    //   name: "Twirling Lotus",
    //   image: 2,
    //   shortName: 'Nilou',
    //   start: '2023-04-12 06:00:00',
    //   end: '2023-05-02 17:59:59',
    //   color: '#b2e0f0',
    //   featured: ['nahida', 'nilou'],
    //   featuredRare: ['kuki_shinobu', 'dori', 'layla'],
    //   timezoneDependent: true,
    //   version: '3.6',
    // },
    {
      name: 'Immaculate Pulse',
      image: 1,
      shortName: 'Baizhu',
      start: '2023-05-02 18:00:00',
      end: '2023-05-23 14:59:59',
      color: '#8fdaa0',
      featured: ['baizhu', 'ganyu'],
      featuredRare: ['kaveh', 'candace', 'fischl'],
      version: '3.6',
    },
    // {
    //   name: "Adrift in the Harbor",
    //   image: 4,
    //   shortName: 'Ganyu',
    //   start: '2023-04-12 06:00:00',
    //   end: '2023-05-02 17:59:59',
    //   color: '#6994DF',
    //   featured: ['baizhu', 'ganyu'],
    //   featuredRare: ['kaveh', 'candace', 'fischl'],
    //   version: '3.6',
    // },
    {
      name: 'Tapestry of Golden Flames',
      image: 4,
      shortName: 'Yoimiya',
      start: '2023-05-24 06:00:00',
      end: '2023-06-13 17:59:59',
      color: '#fc8976',
      featured: ['yoimiya', 'yae_miko'],
      featuredRare: ['kirara', 'yun_jin', 'chongyun'],
      timezoneDependent: true,
      version: '3.7',
    },
    // {
    //   name: 'Everbloom Violet',
    //   image: 3,
    //   shortName: 'Yae Miko',
    //   start: '2023-05-24 06:00:00',
    //   end: '2023-06-13 17:59:59',
    //   color: '#ffd1f9',
    //   featured: ['yoimiya', 'yae_miko'],
    //   featuredRare: ['kirara', 'yun_jin', 'chongyun'],
    //   timezoneDependent: true,
    //   version: '3.7',
    // },
    {
      name: 'Caution in Confidence',
      image: 2,
      shortName: 'Alhaitham',
      start: '2023-06-13 18:00:00',
      end: '2023-07-04 14:59:59',
      color: '#5bcbd1',
      featured: ['alhaitham', 'kaedehara_kazuha'],
      featuredRare: ['yaoyao', 'shikanoin_heizou', 'xiangling'],
      version: '3.7',
    },
    // {
    //   name: 'Leaves in the Wind',
    //   image: 3,
    //   shortName: 'Kazuha',
    //   start: '2023-06-13 18:00:00',
    //   end: '2023-07-04 14:59:59',
    //   color: '#5bcbd1',
    //   featured: ['alhaitham', 'kaedehara_kazuha'],
    //   featuredRare: ['yaoyao', 'shikanoin_heizou', 'xiangling'],
    //   version: '3.7',
    // },
    {
      name: 'Born of Ocean Swell',
      image: 3,
      shortName: 'Eula',
      start: '2023-07-05 06:00:00',
      end: '2023-07-25 17:59:59',
      color: '#A6D6E0',
      featured: ['eula', 'klee'],
      featuredRare: ['mika', 'razor', 'thoma'],
      version: '3.8',
      timezoneDependent: true,
    },
    // {
    //   name: 'Sparkling Steps',
    //   image: 4,
    //   shortName: 'Klee',
    //   start: '2023-07-05 06:00:00',
    //   end: '2023-07-25 17:59:59',
    //   color: '#A6D6E0',
    //   featured: ['eula', 'klee'],
    //   featuredRare: ['mika', 'razor', 'thoma'],
    //   version: '3.8',
    //   timezoneDependent: true,
    // },
    {
      name: 'Drifting Luminescence',
      image: 4,
      shortName: 'Kokomi',
      start: '2023-07-25 18:00:00',
      end: '2023-08-15 17:59:59',
      color: '#53caf3',
      featured: ['sangonomiya_kokomi', 'wanderer'],
      featuredRare: ['yanfei', 'faruzan', 'rosaria'],
      version: '3.8',
    },
    // {
    //   name: 'From Ashes Reborn',
    //   image: 2,
    //   shortName: 'Wanderer',
    //   start: '2023-07-25 18:00:00',
    //   end: '2023-08-15 17:59:59',
    //   color: '#53caf3',
    //   featured: ['sangonomiya_kokomi', 'wanderer'],
    //   featuredRare: ['yanfei', 'faruzan', 'rosaria'],
    //   version: '3.8',
    //   timezoneDependent: true,
    // },
    {
      name: 'Conjuring Chiaroscuro',
      image: 1,
      shortName: 'Lyney',
      start: '2023-08-16 06:00:00',
      end: '2023-09-05 17:59:59',
      color: '#fcc6c8',
      featured: ['lyney', 'yelan'],
      featuredRare: ['bennett', 'barbara', 'lynette'],
      version: '4.0',
      timezoneDependent: true,
    },
    // {
    //   name: 'Discerner of Enigmas',
    //   image: 3,
    //   shortName: 'Yelan',
    //   start: '2023-08-16 06:00:00',
    //   end: '2023-09-05 17:59:59',
    //   color: '#fcc6c8',
    //   featured: ['lyney', 'yelan'],
    //   featuredRare: ['bennett', 'barbara', 'lynette'],
    //   version: '4.0',
    //   timezoneDependent: true,
    // },
    {
      name: 'Gentry of Hermitage',
      image: 5,
      shortName: 'Zhongli',
      start: '2023-09-05 18:00:00',
      end: '2023-09-26 14:59:59',
      color: '#D1A55C',
      featured: ['tartaglia', 'zhongli'],
      featuredRare: ['freminet', 'sayu', 'noelle'],
      version: '4.0',
    },
    // {
    //   name: 'Farewell of Snezhnaya',
    //   image: 5,
    //   shortName: 'Tartaglia',
    //   start: '2023-09-05 18:00:00',
    //   end: '2023-09-26 14:59:59',
    //   color: '#4ED8F3',
    //   featured: ['tartaglia', 'zhongli'],
    //   featuredRare: ['freminet', 'sayu', 'noelle'],
    //   version: '4.0',
    // },
    {
      name: 'Decree of the Deeps',
      image: 1,
      shortName: 'Neuvillette',
      start: '2023-09-27 06:00:00',
      end: '2023-10-17 17:59:59',
      color: '#D1A55C',
      featured: ['neuvillette', 'hu_tao'],
      featuredRare: ['fischl', 'xingqiu', 'diona'],
      version: '4.1',
      timezoneDependent: true,
    },
    // {
    //   name: 'Moment of Bloom',
    //   image: 4,
    //   shortName: 'Hu Tao',
    //   start: '2023-09-27 06:00:00',
    //   end: '2023-10-17 17:59:59',
    //   color: '#FF7966',
    //   featured: ['neuvillette', 'hu_tao'],
    //   featuredRare: ['fischl', 'xingqiu', 'diona'],
    //   version: '4.1',
    //   timezoneDependent: true,
    // },
    {
      name: 'Tempestuous Destiny',
      image: 1,
      shortName: 'Wriothesley',
      start: '2023-10-17 18:00:00',
      end: '2023-11-07 14:59:59',
      color: '#b3d7f1',
      featured: ['wriothesley', 'venti'],
      featuredRare: ['chongyun', 'thoma', 'dori'],
      version: '4.1',
    },
    // {
    //   name: 'Ballad in Goblets',
    //   image: 5,
    //   shortName: 'Venti',
    //   start: '2023-10-17 18:00:00',
    //   end: '2023-11-07 14:59:59',
    //   color: '#96f6de',
    //   featured: ['wriothesley', 'venti'],
    //   featuredRare: ['chongyun', 'thoma', 'dori'],
    //   version: '4.1',
    // },
    {
      name: 'Chanson of Many Waters',
      image: 1,
      shortName: 'Furina',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#95d6fb',
      featured: ['furina', 'baizhu'],
      featuredRare: ['charlotte', 'collei', 'beidou'],
      version: '4.2',
      timezoneDependent: true,
    },
    // {
    //   name: 'Immaculate Pulse',
    //   image: 2,
    //   shortName: 'Baizhu',
    //   start: '2023-11-08 06:00:00',
    //   end: '2023-11-28 17:59:59',
    //   color: '#8fdaa0',
    //   featured: ['furina', 'baizhu'],
    //   featuredRare: ['charlotte', 'collei', 'beidou'],
    //   version: '4.2',
    //   timezoneDependent: true,
    // },
    {
      name: 'Twilight Arbiter',
      image: 3,
      shortName: 'Cyno',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#d8b8f7',
      featured: ['cyno', 'kamisato_ayato'],
      featuredRare: ['kuki_shinobu', 'xiangling', 'kirara'],
      version: '4.2',
    },
    // {
    //   name: 'Azure Excursion',
    //   image: 3,
    //   shortName: 'Ayato',
    //   start: '2023-11-28 18:00:00',
    //   end: '2023-12-19 14:59:59',
    //   color: '#90bce9',
    //   featured: ['cyno', 'kamisato_ayato'],
    //   featuredRare: ['kuki_shinobu', 'xiangling', 'kirara'],
    //   version: '4.2',
    // },
    {
      name: 'In the Name of the Rosula',
      image: 1,
      shortName: 'Navia',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#f6e195',
      featured: ['navia', 'kamisato_ayaka'],
      featuredRare: ['sucrose', 'candace', 'rosaria'],
      version: '4.3',
      timezoneDependent: true,
    },
    // {
    //   name: 'The Heron's Court',
    //   image: 4,
    //   shortName: 'Ayaka',
    //   start: '2023-12-20 06:00:00',
    //   end: '2024-01-09 17:59:59',
    //   color: '#f6e195',
    //   featured: ['navia', 'kamisato_ayaka'],
    //   featuredRare: ['sucrose', 'candace', 'rosaria'],
    //   version: '4.3',
    //   timezoneDependent: true,
    // },
    {
      name: 'Reign of Serenity',
      image: 4,
      shortName: 'Raiden',
      start: '2024-01-09 18:00:00',
      end: '2024-01-30 14:59:00',
      color: '#D0AEF2',
      featured: ['raiden_shogun', 'yoimiya'],
      featuredRare: ['bennett', 'kujou_sara', 'chevreuse'],
      version: '4.3',
    },
    // {
    //   name: 'Tapestry of Golden Flames',
    //   image: 5,
    //   shortName: 'Yoimiya',
    //   start: '2024-01-09 18:00:00',
    //   end: '2024-01-30 14:59:00',
    //   color: '#D0AEF2',
    //   featured: ['raiden_shogun', 'yoimiya'],
    //   featuredRare: ['bennett', 'kujou_sara', 'chevreuse'],
    //   version: '4.3',
    // },
    {
      name: 'The Crane Soars Skyward',
      image: 1,
      shortName: 'Xianyun',
      start: '2024-01-31 06:00:00',
      end: '2024-02-20 17:59:00',
      color: '#affcd1',
      featured: ['xianyun', 'nahida'],
      featuredRare: ['gaming', 'faruzan', 'noelle'],
      version: '4.4',
      timezoneDependent: true,
    },
    // {
    //   name: "The Moongrass' Enlightenment",
    //   image: 3,
    //   shortName: 'Nahida',
    //   start: '2024-01-31 06:00:00',
    //   end: '2024-02-20 17:59:00',
    //   color: '#b8db94',
    //   featured: ['xianyun', 'nahida'],
    //   featuredRare: ['gaming', 'faruzan', 'noelle'],
    //   version: '4.4',
    //   timezoneDependent: true,
    // },
    {
      name: 'Invitation to Mundane Life',
      image: 5,
      shortName: 'Xiao',
      start: '2024-02-20 18:00:00',
      end: '2024-03-12 14:59:00',
      color: '#25d7b8',
      featured: ['xiao', 'yae_miko'],
      featuredRare: ['yaoyao', 'xinyan', 'ningguang'],
      version: '4.4',
    },
    // {
    //   name: 'Everbloom Violet',
    //   image: 4,
    //   shortName: 'Yae',
    //   start: '2024-02-20 18:00:00',
    //   end: '2024-03-12 14:59:00',
    //   color: '#ffd1f9',
    //   featured: ['xiao', 'yae_miko'],
    //   featuredRare: ['yaoyao', 'xinyan', 'ningguang'],
    //   version: '4.4',
    // },
    {
      name: 'Of Silken Clouds Woven',
      image: 1,
      shortName: 'Chiori',
      start: '2024-03-13 06:00:00',
      end: '2024-04-02 17:59:00',
      color: '#ffbd34',
      featured: ['chiori', 'arataki_itto'],
      featuredRare: ['yun_jin', 'gorou', 'dori'],
      version: '4.5',
      timezoneDependent: true,
    },
    // {
    //   name: "Oni's Royale",
    //   image: 4,
    //   shortName: 'Itto',
    //   start: '2024-03-13 06:00:00',
    //   end: '2024-04-02 17:59:00',
    //   color: '#ffb354',
    //   featured: ['chiori', 'arataki_itto'],
    //   featuredRare: ['yun_jin', 'gorou', 'dori'],
    //   version: '4.5',
    //   timezoneDependent: true,
    // },
    {
      name: 'Decree of the Deeps',
      image: 2,
      shortName: 'Neuvillette',
      start: '2024-04-02 18:00:00',
      end: '2024-04-23 14:59:00',
      color: '#72fefd',
      featured: ['neuvillette', 'kaedehara_kazuha'],
      featuredRare: ['barbara', 'xingqiu', 'yanfei'],
      version: '4.5',
    },
    // {
    //   name: 'Leaves in the Wind',
    //   image: 4,
    //   shortName: 'Kazuha',
    //   start: '2024-04-02 18:00:00',
    //   end: '2024-04-23 14:59:00',
    //   color: '#8FFFDE',
    //   featured: ['neuvillette', 'kaedehara_kazuha'],
    //   featuredRare: ['barbara', 'xingqiu', 'yanfei'],
    //   version: '4.5',
    // },
    {
      name: "The Hearth's Ashen Shadow",
      image: 1,
      shortName: 'Arlecchino',
      start: '2024-04-24 06:00:00',
      end: '2024-05-14 17:59:00',
      color: '#f8f8f8',
      featured: ['arlecchino', 'lyney'],
      featuredRare: ['freminet', 'lynette', 'xiangling'],
      version: '4.6',
      timezoneDependent: true,
    },
    // {
    //   name: 'Conjuring Chiaroscuro',
    //   image: 2,
    //   shortName: 'Lyney',
    //   start: '2024-04-24 06:00:00',
    //   end: '2024-05-14 17:59:00',
    //   color: '#fcc6c8',
    //   featured: ['arlecchino', 'lyney'],
    //   featuredRare: ['freminet', 'lynette', 'xiangling'],
    //   version: '4.6',
    //   timezoneDependent: true,
    // },
    {
      name: 'From Ashes Reborn',
      image: 3,
      shortName: 'Wanderer',
      start: '2024-05-14 18:00:00',
      end: '2024-06-04 14:59:00',
      color: '#31cae1',
      featured: ['wanderer', 'baizhu'],
      featuredRare: ['layla', 'faruzan', 'beidou'],
      version: '4.6',
    },
    // {
    //   name: 'Immaculate Pulse',
    //   image: 3,
    //   shortName: 'Baizhu',
    //   start: '2024-05-14 18:00:00',
    //   end: '2024-06-04 14:59:00',
    //   color: '#8fdaa0',
    //   featured: ['wanderer', 'baizhu'],
    //   featuredRare: ['layla', 'faruzan', 'beidou'],
    //   version: '4.6',
    // },
    {
      name: 'Illuminating Lightning',
      image: 1,
      shortName: 'Clorinde',
      start: '2024-06-05 06:00:00',
      end: '2024-06-25 17:59:00',
      color: '#6968ff',
      featured: ['clorinde', 'alhaitham'],
      featuredRare: ['sethos', 'bennett', 'thoma'],
      version: '4.7',
      timezoneDependent: true,
    },
    // {
    //   name: 'Caution in Confidence',
    //   image: 3,
    //   shortName: 'Alhaitham',
    //   start: '2024-06-05 06:00:00',
    //   end: '2024-06-25 17:59:00',
    //   color: '#5bcbd1',
    //   featured: ['clorinde', 'alhaitham'],
    //   featuredRare: ['sethos', 'bennett', 'thoma'],
    //   version: '4.7',
    //   timezoneDependent: true,
    // },
    {
      name: 'Romaritime Meluserenity',
      image: 1,
      shortName: 'Sigewinne',
      start: '2024-06-25 18:00:00',
      end: '2024-07-16 14:59:00',
      color: '#fadbf8',
      featured: ['sigewinne', 'furina'],
      featuredRare: ['noelle', 'gaming', 'rosaria'],
      version: '4.7',
    },
    // {
    //   name: 'Chanson of Many Waters',
    //   image: 2,
    //   shortName: 'Furina',
    //   start: '2024-06-25 18:00:00',
    //   end: '2024-07-16 14:59:00',
    //   color: '#95d6fb',
    //   featured: ['sigewinne', 'furina'],
    //   featuredRare: ['noelle', 'gaming', 'rosaria'],
    //   version: '4.7',
    // },
    {
      name: 'In the Name of the Rosula',
      image: 2,
      shortName: 'Navia',
      start: '2024-07-17 06:00:00',
      end: '2024-08-06 17:59:00',
      color: '#fadbf8',
      featured: ['navia', 'nilou'],
      featuredRare: ['kirara', 'kaveh', 'ningguang'],
      version: '4.8',
      timezoneDependent: true,
    },
    // {
    //   name: 'Twirling Lotus',
    //   image: 3,
    //   shortName: 'Nilou',
    //   start: '2024-07-17 06:00:00',
    //   end: '2024-08-06 17:59:00',
    //   color: '#b2e0f0',
    //   featured: ['navia', 'nilou'],
    //   featuredRare: ['kirara', 'kaveh', 'ningguang'],
    //   version: '4.8',
    //   timezoneDependent: true,
    // },
    {
      name: 'Ambrosial Essence',
      image: 1,
      shortName: 'Emilie',
      start: '2024-08-06 18:00:00',
      end: '2024-08-27 14:59:00',
      color: '#cde8a4',
      featured: ['emilie', 'yelan'],
      featuredRare: ['yanfei', 'xiangling', 'razor'],
      version: '4.8',
    },
    // {
    //   name: 'Discerner of Enigmas',
    //   image: 4,
    //   shortName: 'Yelan',
    //   start: '2024-08-06 18:00:00',
    //   end: '2024-08-27 14:59:00',
    //   color: '#7de6fd',
    //   featured: ['emilie', 'yelan'],
    //   featuredRare: ['yanfei', 'xiangling', 'razor'],
    //   version: '4.8',
    // },
    {
      name: 'Sharktacular Surfari',
      image: 1,
      shortName: 'Mualani',
      start: '2024-08-28 06:00:00',
      end: '2024-09-17 17:59:00',
      color: '#6fc5e2',
      featured: ['mualani', 'kaedehara_kazuha'],
      featuredRare: ['kachina', 'xinyan', 'bennett'],
      version: '5.0',
      timezoneDependent: true,
    },
    // {
    //   name: 'Leaves in the Wind',
    //   image: 5,
    //   shortName: 'Kazuha',
    //   start: '2024-08-28 06:00:00',
    //   end: '2024-09-17 17:59:00',
    //   color: '#8FFFDE',
    //   featured: ['mualani', 'kaedehara_kazuha'],
    //   featuredRare: ['kachina', 'xinyan', 'bennett'],
    //   version: '5.0',
    //   timezoneDependent: true,
    // },
  ],
  weapons: [
    {
      name: 'Epitome Invocation',
      image: 1,
      start: '2020-09-28 00:00:00',
      end: '2020-10-18 18:00:00',
      shortName: 'Amos',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['aquila_favonia', 'amos_bow'],
      featuredRare: ['the_flute', 'the_bell', 'the_widsith', 'the_stringless', 'favonius_lance'],
      version: '1.0',
    },
    {
      name: 'Epitome Invocation',
      image: 2,
      start: '2020-10-20 18:00:00',
      end: '2020-11-10 16:00:00',
      shortName: 'Lost Prayer',
      color: '#eae5e1',
      featured: ['lost_prayer_to_the_sacred_winds', 'wolfs_gravestone'],
      featuredRare: [
        'sacrificial_sword',
        'sacrificial_bow',
        'sacrificial_greatsword',
        'sacrificial_fragments',
        'dragons_bane',
      ],
      version: '1.0',
    },
    {
      name: 'Epitome Invocation',
      image: 3,
      start: '2020-11-11 06:00:00',
      end: '2020-12-01 16:00:00',
      shortName: 'Skyward',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['skyward_harp', 'memory_of_dust'],
      featuredRare: ['the_flute', 'rainslasher', 'eye_of_perception', 'rust', 'favonius_lance'],
      version: '1.1',
    },
    {
      name: 'Epitome Invocation',
      image: 4,
      start: '2020-12-01 18:00:00',
      end: '2020-12-22 15:00:00',
      shortName: 'Vortex',
      color: '#eae5e1',
      featured: ['vortex_vanquisher', 'the_unforged'],
      featuredRare: ['lions_roar', 'the_bell', 'favonius_codex', 'favonius_warbow', 'dragons_bane'],
      version: '1.1',
    },
    {
      name: 'Epitome Invocation',
      image: 5,
      start: '2020-12-23 06:00:00',
      end: '2021-01-12 16:00:00',
      shortName: 'Summit',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['summit_shaper', 'skyward_atlas'],
      featuredRare: [
        'favonius_sword',
        'favonius_greatsword',
        'favonius_lance',
        'sacrificial_fragments',
        'the_stringless',
      ],
      version: '1.2',
    },
    {
      name: 'Epitome Invocation',
      image: 6,
      start: '2021-01-12 18:00:00',
      end: '2021-02-02 15:00:00',
      shortName: 'Amos',
      color: '#eae5e1',
      featured: ['amos_bow', 'skyward_pride'],
      featuredRare: ['sacrificial_sword', 'the_bell', 'dragons_bane', 'eye_of_perception', 'favonius_warbow'],
      version: '1.2',
    },
    {
      name: 'Epitome Invocation',
      image: 7,
      start: '2021-02-03 06:00:00',
      end: '2021-02-23 16:00:00',
      shortName: 'Primordial',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['primordial_jade_winged-spear', 'primordial_jade_cutter'],
      featuredRare: ['the_flute', 'sacrificial_greatsword', 'rust', 'eye_of_perception', 'favonius_lance'],
      version: '1.3',
    },
    {
      name: 'Epitome Invocation',
      image: 8,
      start: '2021-02-23 18:00:00',
      end: '2021-03-16 15:00:00',
      shortName: 'Homa',
      color: '#eae5e1',
      featured: ['wolfs_gravestone', 'staff_of_homa'],
      featuredRare: ['lithic_blade', 'lithic_spear', 'lions_roar', 'sacrificial_bow', 'the_widsith'],
      version: '1.3',
    },
    {
      name: 'Epitome Invocation',
      image: 9,
      start: '2021-03-17 06:00:00',
      end: '2021-04-06 16:00:00',
      shortName: 'Elegy',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['elegy_for_the_end', 'skyward_blade'],
      featuredRare: ['the_alley_flash', 'wine_and_song', 'favonius_greatsword', 'favonius_warbow', 'dragons_bane'],
      version: '1.4',
    },
    {
      name: 'Epitome Invocation',
      image: 10,
      start: '2021-04-06 18:00:00',
      end: '2021-04-27 15:00:00',
      shortName: 'Skyward',
      color: '#eae5e1',
      featured: ['skyward_harp', 'lost_prayer_to_the_sacred_winds'],
      featuredRare: ['alley_hunter', 'favonius_codex', 'favonius_lance', 'sacrificial_greatsword', 'favonius_sword'],
      version: '1.4',
    },
    {
      name: 'Epitome Invocation',
      image: 11,
      start: '2021-04-28 06:00:00',
      end: '2021-05-18 17:59:59',
      shortName: 'Summit',
      color: '#ffb169',
      timezoneDependent: true,
      featured: ['summit_shaper', 'memory_of_dust'],
      featuredRare: ['lithic_blade', 'lithic_spear', 'sacrificial_bow', 'eye_of_perception', 'the_flute'],
      version: '1.5',
    },
    {
      name: 'Epitome Invocation',
      image: 12,
      start: '2021-05-18 18:00:00',
      end: '2021-06-08 15:00:00',
      shortName: 'Pines',
      color: '#eae5e1',
      featured: ['song_of_broken_pines', 'aquila_favonia'],
      featuredRare: ['rust', 'sacrificial_fragments', 'dragons_bane', 'rainslasher', 'sacrificial_sword'],
      version: '1.5',
    },
    {
      name: 'Epitome Invocation',
      image: 13,
      start: '2021-06-09 06:00:00',
      end: '2021-06-29 17:59:59',
      shortName: 'Lost Prayer',
      color: '#ffb169',
      featured: ['lost_prayer_to_the_sacred_winds', 'skyward_pride'],
      featuredRare: ['mitternachts_waltz', 'lions_roar', 'the_bell', 'favonius_lance', 'the_widsith'],
      timezoneDependent: true,
      version: '1.6',
    },
    {
      name: 'Epitome Invocation',
      image: 14,
      start: '2021-06-29 18:00:00',
      end: '2021-07-20 14:59:59',
      shortName: 'Freedom-Sworn',
      color: '#eae5e1',
      featured: ['freedom-sworn', 'skyward_atlas'],
      featuredRare: ['the_alley_flash', 'wine_and_song', 'alley_hunter', 'favonius_greatsword', 'dragons_bane'],
      version: '1.6',
    },
    {
      name: 'Epitome Invocation',
      image: 15,
      start: '2021-07-21 06:00:00',
      end: '2021-08-10 17:59:59',
      shortName: 'Mistsplitter',
      color: '#ffb169',
      featured: ['mistsplitter_reforged', 'skyward_spine'],
      featuredRare: ['favonius_sword', 'sacrificial_greatsword', 'favonius_lance', 'favonius_codex', 'the_stringless'],
      timezoneDependent: true,
      version: '2.0',
    },
    {
      name: 'Epitome Invocation',
      image: 16,
      start: '2021-08-10 18:00:00',
      end: '2021-08-31 14:59:59',
      shortName: 'Thundering Pulse',
      color: '#eae5e1',
      featured: ['thundering_pulse', 'skyward_blade'],
      featuredRare: ['sacrificial_sword', 'rainslasher', 'dragons_bane', 'sacrificial_fragments', 'favonius_warbow'],
      version: '2.0',
    },
    {
      name: 'Epitome Invocation',
      image: 17,
      start: '2021-09-01 06:00:00',
      end: '2021-09-21 17:59:59',
      shortName: 'Engulfing',
      color: '#ffb169',
      featured: ['engulfing_lightning', 'the_unforged'],
      featuredRare: ['lions_roar', 'the_bell', 'favonius_lance', 'the_widsith', 'sacrificial_bow'],
      timezoneDependent: true,
      version: '2.1',
    },
    {
      name: 'Epitome Invocation',
      image: 18,
      start: '2021-09-21 18:00:00',
      end: '2021-10-12 14:59:59',
      shortName: 'Moonglow',
      color: '#eae5e1',
      featured: ['primordial_jade_cutter', 'everlasting_moonglow'],
      featuredRare: ['the_flute', 'favonius_greatsword', 'dragons_bane', 'favonius_codex', 'the_stringless'],
      version: '2.1',
    },
    {
      name: 'Epitome Invocation',
      image: 19,
      start: '2021-10-13 06:00:00',
      end: '2021-11-02 17:59:59',
      shortName: 'Polar Star',
      color: '#ffb169',
      featured: ['polar_star', 'memory_of_dust'],
      featuredRare: ['akuoumaru', 'favonius_sword', 'favonius_lance', 'eye_of_perception', 'rust'],
      timezoneDependent: true,
      version: '2.2',
    },
    {
      name: 'Epitome Invocation',
      image: 20,
      start: '2021-11-02 18:00:00',
      end: '2021-11-23 14:59:59',
      shortName: 'Homa',
      color: '#eae5e1',
      featured: ['staff_of_homa', 'elegy_for_the_end'],
      featuredRare: ['wavebreakers_fin', 'mouuns_moon', 'sacrificial_sword', 'rainslasher', 'the_widsith'],
      version: '2.2',
    },
    {
      name: 'Epitome Invocation',
      image: 21,
      start: '2021-11-24 06:00:00',
      end: '2021-12-14 17:59:59',
      shortName: 'Freedom',
      color: '#ffb169',
      featured: ['freedom-sworn', 'song_of_broken_pines'],
      featuredRare: ['wine_and_song', 'alley_hunter', 'lions_roar', 'sacrificial_greatsword', 'dragons_bane'],
      timezoneDependent: true,
      version: '2.3',
    },
    {
      name: 'Epitome Invocation',
      image: 22,
      start: '2021-12-14 18:00:00',
      end: '2022-01-04 17:59:59',
      shortName: 'Redhorn',
      color: '#eae5e1',
      featured: ['redhorn_stonethresher', 'skyward_harp'],
      featuredRare: ['the_alley_flash', 'mitternachts_waltz', 'the_bell', 'favonius_lance', 'sacrificial_fragments'],
      timezoneDependent: true,
      version: '2.3',
    },
    {
      name: 'Epitome Invocation',
      image: 23,
      start: '2022-01-05 06:00:00',
      end: '2022-01-25 17:59:59',
      shortName: 'Queller',
      color: '#ffb169',
      featured: ['calamity_queller', 'primordial_jade_winged-spear'],
      featuredRare: ['lithic_spear', 'the_flute', 'favonius_greatsword', 'the_widsith', 'favonius_warbow'],
      timezoneDependent: true,
      version: '2.4',
    },
    {
      name: 'Epitome Invocation',
      image: 24,
      start: '2022-01-25 18:00:00',
      end: '2022-02-15 14:59:59',
      shortName: 'Amos',
      color: '#eae5e1',
      featured: ['amos_bow', 'vortex_vanquisher'],
      featuredRare: ['lithic_blade', 'favonius_sword', 'dragons_bane', 'favonius_codex', 'sacrificial_bow'],
      version: '2.4',
    },
    {
      name: 'Epitome Invocation',
      image: 25,
      start: '2022-02-16 06:00:00',
      end: '2022-03-08 17:59:59',
      shortName: 'Verity',
      color: '#ffb169',
      featured: ['kaguras_verity', 'primordial_jade_cutter'],
      featuredRare: ['wavebreakers_fin', 'sacrificial_sword', 'rainslasher', 'eye_of_perception', 'the_stringless'],
      timezoneDependent: true,
      version: '2.5',
    },
    {
      name: 'Epitome Invocation',
      image: 26,
      start: '2022-03-08 18:00:00',
      end: '2022-03-29 14:59:59',
      shortName: 'Engulfing',
      color: '#eae5e1',
      featured: ['engulfing_lightning', 'everlasting_moonglow'],
      featuredRare: ['akuoumaru', 'mouuns_moon', 'lions_roar', 'favonius_lance', 'sacrificial_fragments'],
      version: '2.5',
    },
    {
      name: 'Epitome Invocation',
      image: 27,
      start: '2022-03-30 06:00:00',
      end: '2022-04-19 17:59:59',
      shortName: 'Haran',
      color: '#ffb169',
      featured: ['haran_geppaku_futsu', 'elegy_for_the_end'],
      featuredRare: ['the_flute', 'sacrificial_greatsword', 'dragons_bane', 'the_widsith', 'rust'],
      timezoneDependent: true,
      version: '2.6',
    },
    {
      name: 'Epitome Invocation',
      image: 28,
      start: '2022-04-19 18:00:00',
      end: '2022-05-31 05:59:59',
      shortName: 'Mistsplitter',
      color: '#eae5e1',
      featured: ['mistsplitter_reforged', 'the_unforged'],
      featuredRare: ['favonius_sword', 'the_bell', 'favonius_lance', 'favonius_codex', 'favonius_warbow'],
      timezoneDependentEnd: true,
      version: '2.6',
    },
    {
      name: 'Epitome Invocation',
      image: 29,
      start: '2022-05-31 09:00:00',
      end: '2022-06-21 17:59:59',
      shortName: 'Aqua',
      color: '#ffb169',
      featured: ['aqua_simulacra', 'primordial_jade_winged-spear'],
      featuredRare: [
        'lithic_spear',
        'sacrificial_sword',
        'favonius_greatsword',
        'eye_of_perception',
        'sacrificial_bow',
      ],
      timezoneDependent: true,
      version: '2.7',
    },
    {
      name: 'Epitome Invocation',
      image: 30,
      start: '2022-06-21 18:00:00',
      end: '2022-07-12 14:59:59',
      shortName: 'Redhorn',
      color: '#eae5e1',
      featured: ['redhorn_stonethresher', 'memory_of_dust'],
      featuredRare: ['lithic_blade', 'lions_roar', 'dragons_bane', 'sacrificial_fragments', 'the_stringless'],
      version: '2.7',
    },
    {
      name: 'Epitome Invocation',
      image: 31,
      start: '2022-07-13 06:00:00',
      end: '2022-08-02 17:59:59',
      shortName: 'Freedom-Sworn',
      color: '#ffb169',
      featured: ['freedom-sworn', 'lost_prayer_to_the_sacred_winds'],
      featuredRare: ['the_alley_flash', 'mitternachts_waltz', 'rainslasher', 'favonius_lance', 'the_widsith'],
      timezoneDependent: true,
      version: '2.8',
    },
    {
      name: 'Epitome Invocation',
      image: 32,
      start: '2022-08-02 18:00:00',
      end: '2022-08-23 14:59:59',
      shortName: 'Thundering',
      color: '#eae5e1',
      featured: ['thundering_pulse', 'summit_shaper'],
      featuredRare: ['wine_and_song', 'alley_hunter', 'the_flute', 'sacrificial_greatsword', 'dragons_bane'],
      version: '2.8',
    },
    {
      name: 'Epitome Invocation',
      image: 33,
      start: '2022-08-24 06:00:00',
      end: '2022-09-09 17:59:59',
      shortName: 'Hunters',
      color: '#ffb169',
      featured: ['hunters_path', 'vortex_vanquisher'],
      featuredRare: ['favonius_sword', 'the_bell', 'favonius_lance', 'favonius_codex', 'the_stringless'],
      timezoneDependent: true,
      version: '3.0',
    },
    {
      name: 'Epitome Invocation',
      image: 34,
      start: '2022-09-09 18:00:00',
      end: '2022-09-27 14:59:59',
      shortName: 'Amos',
      color: '#eae5e1',
      featured: ['amos_bow', 'everlasting_moonglow'],
      featuredRare: ['sacrificial_sword', 'favonius_greatsword', 'dragons_bane', 'eye_of_perception', 'rust'],
      version: '3.0',
    },
    {
      name: 'Epitome Invocation',
      image: 35,
      start: '2022-09-28 06:00:00',
      end: '2022-10-14 17:59:59',
      shortName: 'Scarlet',
      color: '#ffb169',
      featured: ['staff_of_the_scarlet_sands', 'elegy_for_the_end'],
      featuredRare: ['makhaira_aquamarine', 'lions_roar', 'favonius_lance', 'sacrificial_fragments', 'favonius_warbow'],
      timezoneDependent: true,
      version: '3.1',
    },
    {
      name: 'Epitome Invocation',
      image: 36,
      start: '2022-10-14 18:00:00',
      end: '2022-11-01 14:59:59',
      shortName: 'Nisut',
      color: '#eae5e1',
      featured: ['key_of_khaj-nisut', 'primordial_jade_cutter'],
      featuredRare: ['xiphos_moonlight', 'wandering_evenstar', 'rainslasher', 'dragons_bane', 'sacrificial_bow'],
      version: '3.1',
    },
    {
      name: 'Epitome Invocation',
      image: 37,
      start: '2022-11-02 06:00:00',
      end: '2022-11-18 17:59:59',
      shortName: 'Dreams',
      color: '#ffb169',
      featured: ['a_thousand_floating_dreams', 'thundering_pulse'],
      featuredRare: ['the_flute', 'sacrificial_greatsword', 'favonius_lance', 'the_widsith', 'rust'],
      timezoneDependent: true,
      version: '3.2',
    },
    {
      name: 'Epitome Invocation',
      image: 38,
      start: '2022-11-18 18:00:00',
      end: '2022-12-06 14:59:59',
      shortName: 'Kagura',
      color: '#eae5e1',
      featured: ['kaguras_verity', 'polar_star'],
      featuredRare: ['favonius_sword', 'the_bell', 'dragons_bane', 'favonius_codex', 'the_stringless'],
      version: '3.2',
    },
    {
      name: 'Epitome Invocation',
      image: 39,
      start: '2022-12-07 06:00:00',
      end: '2022-12-27 17:59:59',
      shortName: 'Tulaytullah',
      color: '#ffb169',
      featured: ['tulaytullahs_remembrance', 'redhorn_stonethresher'],
      featuredRare: [
        'wavebreakers_fin',
        'sacrificial_sword',
        'favonius_greatsword',
        'eye_of_perception',
        'favonius_warbow',
      ],
      timezoneDependent: true,
      version: '3.3',
    },
    {
      name: 'Epitome Invocation',
      image: 40,
      shortName: 'Egulfing',
      start: '2022-12-27 18:00:00',
      end: '2023-01-17 14:59:59',
      color: '#eae5e1',
      featured: ['engulfing_lightning', 'haran_geppaku_futsu'],
      featuredRare: ['akuoumaru', 'mouuns_moon', 'lions_roar', 'favonius_lance', 'sacrificial_fragments'],
      version: '3.3',
    },
    {
      name: 'Epitome Invocation',
      image: 41,
      shortName: 'Incision',
      start: '2023-01-18 06:00:00',
      end: '2023-02-07 17:59:59',
      color: '#ffb169',
      featured: ['light_of_foliar_incision', 'primordial_jade_winged-spear'],
      featuredRare: ['lithic_spear', 'the_flute', 'rainslasher', 'the_widsith', 'sacrificial_bow'],
      timezoneDependent: true,
      version: '3.4',
    },
    {
      name: 'Epitome Invocation',
      image: 42,
      shortName: 'Homa',
      start: '2023-02-07 18:00:00',
      end: '2023-02-28 14:59:59',
      color: '#eae5e1',
      featured: ['staff_of_homa', 'aqua_simulacra'],
      featuredRare: ['lithic_blade', 'favonius_sword', 'dragons_bane', 'favonius_codex', 'rust'],
      version: '3.4',
    },
    {
      name: 'Epitome Invocation',
      image: 43,
      shortName: 'Incision',
      start: '2023-03-01 06:00:00',
      end: '2023-03-21 17:59:59',
      color: '#ffb169',
      featured: ['beacon_of_the_reed_sea', 'staff_of_the_scarlet_sands'],
      featuredRare: ['the_alley_flash', 'alley_hunter', 'sacrificial_greatsword', 'dragons_bane', 'eye_of_perception'],
      timezoneDependent: true,
      version: '3.5',
    },
    {
      name: 'Epitome Invocation',
      image: 44,
      shortName: 'Incision',
      start: '2023-03-21 18:00:00',
      end: '2023-04-11 14:59:59',
      color: '#eae5e1',
      featured: ['calamity_queller', 'mistsplitter_reforged'],
      featuredRare: ['wine_and_song', 'sacrificial_sword', 'the_bell', 'favonius_lance', 'favonius_warbow'],
      version: '3.5',
    },
    {
      name: 'Epitome Invocation',
      image: 45,
      shortName: 'Dreams',
      start: '2023-04-12 06:00:00',
      end: '2023-05-02 17:59:59',
      color: '#ffb169',
      featured: ['key_of_khaj-nisut', 'a_thousand_floating_dreams'],
      featuredRare: [
        'xiphos_moonlight',
        'favonius_greatsword',
        'dragons_bane',
        'sacrificial_fragments',
        'the_stringless',
      ],
      timezoneDependent: true,
      version: '3.6',
    },
    {
      name: 'Epitome Invocation',
      image: 46,
      shortName: 'jadefalls_splendor',
      start: '2023-05-02 18:00:00',
      end: '2023-05-23 14:59:59',
      color: '#eae5e1',
      featured: ['jadefalls_splendor', 'amos_bow'],
      featuredRare: ['makhaira_aquamarine', 'wandering_evenstar', 'lions_roar', 'favonius_lance', 'sacrificial_bow'],
      version: '3.6',
    },
    {
      name: 'Epitome Invocation',
      image: 47,
      shortName: 'Thundering',
      start: '2023-05-24 06:00:00',
      end: '2023-06-13 17:59:59',
      color: '#ffb169',
      featured: ['thundering_pulse', 'kaguras_verity'],
      featuredRare: ['akuoumaru', 'the_flute', 'dragons_bane', 'the_widsith', 'rust'],
      timezoneDependent: true,
      version: '3.7',
    },
    {
      name: 'Epitome Invocation',
      image: 48,
      shortName: 'Freedom',
      start: '2023-06-13 18:00:00',
      end: '2023-07-04 14:59:59',
      color: '#eae5e1',
      featured: ['freedom-sworn', 'light_of_foliar_incision'],
      featuredRare: ['wavebreakers_fin', 'mouuns_moon', 'favonius_sword', 'sacrificial_greatsword', 'favonius_codex'],
      version: '3.7',
    },
    {
      name: 'Epitome Invocation',
      image: 49,
      shortName: 'Freedom',
      start: '2023-07-05 06:00:00',
      end: '2023-07-25 17:59:59',
      color: '#ffb169',
      featured: ['song_of_broken_pines', 'lost_prayer_to_the_sacred_winds'],
      featuredRare: ['the_alley_flash', 'alley_hunter', 'rainslasher', 'favonius_lance', 'eye_of_perception'],
      timezoneDependent: true,
      version: '3.8',
    },
    {
      name: 'Epitome Invocation',
      image: 50,
      shortName: 'Moonglow',
      start: '2023-07-25 18:00:00',
      end: '2023-08-15 17:59:59',
      color: '#eae5e1',
      featured: ['everlasting_moonglow', 'tulaytullahs_remembrance'],
      featuredRare: ['wine_and_song', 'lions_roar', 'the_bell', 'dragons_bane', 'favonius_warbow'],
      version: '3.8',
    },
    {
      name: 'Epitome Invocation',
      image: 51,
      shortName: 'Great Magic',
      start: '2023-08-16 06:00:00',
      end: '2023-09-05 17:59:59',
      color: '#ffb169',
      featured: ['the_first_great_magic', 'aqua_simulacra'],
      featuredRare: [
        'sacrificial_sword',
        'favonius_greatsword',
        'favonius_lance',
        'sacrificial_fragments',
        'sacrificial_bow',
      ],
      version: '4.0',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 52,
      shortName: 'Polar',
      start: '2023-09-05 18:00:00',
      end: '2023-09-26 14:59:59',
      color: '#eae5e1',
      featured: ['polar_star', 'vortex_vanquisher'],
      featuredRare: ['the_flute', 'sacrificial_greatsword', 'dragons_bane', 'the_widsith', 'rust'],
      version: '4.0',
    },
    {
      name: 'Epitome Invocation',
      image: 53,
      shortName: 'Polar',
      start: '2023-09-27 06:00:00',
      end: '2023-10-17 17:59:59',
      color: '#ffb169',
      featured: ['tome_of_the_eternal_flow', 'staff_of_homa'],
      featuredRare: [
        'the_dockhands_assistant',
        'portable_power_saw',
        'mitternachts_waltz',
        'favonius_lance',
        'favonius_codex',
      ],
      version: '4.1',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 54,
      shortName: 'Polar',
      start: '2023-10-17 18:00:00',
      end: '2023-11-07 14:59:59',
      color: '#eae5e1',
      featured: ['cashflow_supervision', 'elegy_for_the_end'],
      featuredRare: ['prospectors_drill', 'range_gauge', 'favonius_sword', 'rainslasher', 'eye_of_perception'],
      version: '4.1',
    },
    {
      name: 'Epitome Invocation',
      image: 55,
      shortName: 'Tranquil',
      start: '2023-11-08 06:00:00',
      end: '2023-11-28 17:59:59',
      color: '#ffb169',
      featured: ['splendor_of_tranquil_waters', 'jadefalls_splendor'],
      featuredRare: ['sacrificial_sword', 'the_bell', 'dragons_bane', 'sacrificial_fragments', 'the_stringless'],
      version: '4.2',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 56,
      shortName: 'Scarlet',
      start: '2023-11-28 18:00:00',
      end: '2023-12-19 14:59:59',
      color: '#eae5e1',
      featured: ['staff_of_the_scarlet_sands', 'haran_geppaku_futsu'],
      featuredRare: ['lions_roar', 'the_widsith', 'favonius_warbow', 'favonius_greatsword', 'favonius_lance'],
      version: '4.2',
    },
    {
      name: 'Epitome Invocation',
      image: 57,
      shortName: 'Verdict',
      start: '2023-12-20 06:00:00',
      end: '2024-01-09 17:59:59',
      color: '#ffb169',
      featured: ['verdict', 'mistsplitter_reforged'],
      featuredRare: ['akuoumaru', 'mouuns_moon', 'the_flute', 'dragons_bane', 'favonius_codex'],
      version: '4.3',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 58,
      shortName: 'Engulfing',
      start: '2024-01-09 18:00:00',
      end: '2024-01-30 14:59:00',
      color: '#eae5e1',
      featured: ['engulfing_lightning', 'thundering_pulse'],
      featuredRare: ['wavebreakers_fin', 'favonius_sword', 'rainslasher', 'eye_of_perception', 'rust'],
      version: '4.3',
    },
    {
      name: 'Epitome Invocation',
      image: 59,
      shortName: 'Crane',
      start: '2024-01-31 06:00:00',
      end: '2024-02-20 17:59:00',
      color: '#ffb169',
      featured: ['cranes_echoing_call', 'a_thousand_floating_dreams'],
      featuredRare: [
        'lithic_spear',
        'sacrificial_sword',
        'sacrificial_greatsword',
        'sacrificial_fragments',
        'sacrificial_bow',
      ],
      version: '4.4',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 60,
      shortName: 'Primordial',
      start: '2024-02-20 18:00:00',
      end: '2024-03-12 14:59:00',
      color: '#eae5e1',
      featured: ['primordial_jade_winged-spear', 'kaguras_verity'],
      featuredRare: ['lithic_blade', 'lions_roar', 'favonius_lance', 'the_widsith', 'the_stringless'],
      version: '4.4',
    },
    {
      name: 'Epitome Invocation',
      image: 61,
      shortName: 'Misugiri',
      start: '2024-03-13 06:00:00',
      end: '2024-04-02 17:59:00',
      color: '#ffb169',
      featured: ['uraku_misugiri', 'redhorn_stonethresher'],
      featuredRare: ['the_alley_flash', 'alley_hunter', 'the_bell', 'dragons_bane', 'favonius_codex'],
      version: '4.5',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 62,
      shortName: 'Eternal',
      start: '2024-04-02 18:00:00',
      end: '2024-04-23 14:59:00',
      color: '#eae5e1',
      featured: ['tome_of_the_eternal_flow', 'freedom-sworn'],
      featuredRare: ['wine_and_song', 'mitternachts_waltz', 'the_flute', 'favonius_greatsword', 'favonius_lance'],
      version: '4.5',
    },
    {
      name: 'Epitome Invocation',
      image: 63,
      shortName: 'Crimson',
      start: '2024-04-24 06:00:00',
      end: '2024-05-14 17:59:00',
      color: '#ffb169',
      featured: ['crimson_moons_semblance', 'the_first_great_magic'],
      featuredRare: [
        'the_dockhands_assistant',
        'portable_power_saw',
        'dragons_bane',
        'eye_of_perception',
        'favonius_warbow',
      ],
      version: '4.6',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 64,
      shortName: 'Tulaytullah',
      start: '2024-05-14 18:00:00',
      end: '2024-06-04 14:59:00',
      color: '#eae5e1',
      featured: ['tulaytullahs_remembrance', 'jadefalls_splendor'],
      featuredRare: ['prospectors_drill', 'range_gauge', 'favonius_sword', 'rainslasher', 'sacrificial_fragments'],
      version: '4.6',
    },
    {
      name: 'Epitome Invocation',
      image: 65,
      shortName: 'Absolution',
      start: '2024-06-05 06:00:00',
      end: '2024-06-25 17:59:00',
      color: '#ffb169',
      featured: ['absolution', 'light_of_foliar_incision'],
      featuredRare: ['lithic_spear', 'sacrificial_sword', 'sacrificial_greatsword', 'the_widsith', 'the_stringless'],
      version: '4.7',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 66,
      shortName: 'Silvershower',
      start: '2024-06-25 18:00:00',
      end: '2024-07-16 14:59:00',
      color: '#eae5e1',
      featured: ['silvershower_heartstrings', 'splendor_of_tranquil_waters'],
      featuredRare: ['lithic_blade', 'lions_roar', 'favonius_lance', 'favonius_codex', 'sacrificial_bow'],
      version: '4.7',
    },
    {
      name: 'Epitome Invocation',
      image: 67,
      shortName: 'Verdict',
      start: '2024-07-17 06:00:00',
      end: '2024-08-06 17:59:00',
      color: '#ffb169',
      featured: ['verdict', 'key_of_khaj-nisut'],
      featuredRare: ['xiphos_moonlight', 'the_bell', 'dragons_bane', 'eye_of_perception', 'rust'],
      version: '4.8',
      timezoneDependent: true,
    },
    {
      name: 'Epitome Invocation',
      image: 68,
      shortName: 'Lumidouce',
      start: '2024-08-06 18:00:00',
      end: '2024-08-27 14:59:00',
      color: '#eae5e1',
      featured: ['lumidouce_elegy', 'aqua_simulacra'],
      featuredRare: ['makhaira_aquamarine', 'wandering_evenstar', 'the_flute', 'favonius_lance', 'favonius_warbow'],
      version: '4.8',
    },
    {
      name: 'Epitome Invocation',
      image: 69,
      shortName: "Surf's Up",
      start: '2024-08-28 06:00:00',
      end: '2024-09-17 17:59:00',
      color: '#eae5e1',
      featured: ['surfs_up', 'freedom-sworn'],
      featuredRare: [
        'favonius_sword',
        'favonius_greatsword',
        'dragons_bane',
        'sacrificial_fragments',
        'the_stringless',
      ],
      version: '5.0',
      timezoneDependent: true,
    },
  ],
  chronicled: [
    {
      name: 'Ode to the Dawn Breeze',
      image: 1,
      shortName: 'Mondstadt',
      start: '2024-03-13 06:00:00',
      end: '2024-04-02 17:59:00',
      color: '#eee8e1',
      featured: [
        'eula',
        'mona',
        'albedo',
        'klee',
        'diluc',
        'jean',
        'skyward_blade',
        'aquila_favonia',
        'beacon_of_the_reed_sea',
        'song_of_broken_pines',
        'wolfs_gravestone',
        'skyward_pride',
        'skyward_spine',
        'lost_prayer_to_the_sacred_winds',
        'skyward_atlas',
        'hunters_path',
        'skyward_harp',
      ],
      featuredRare: [
        'mika',
        'rosaria',
        'sucrose',
        'diona',
        'noelle',
        'bennett',
        'fischl',
        'amber',
        'razor',
        'kaeya',
        'barbara',
        'lisa',
        'the_alley_flash',
        'lions_roar',
        'sacrificial_sword',
        'the_flute',
        'favonius_sword',
        'rainslasher',
        'sacrificial_greatsword',
        'the_bell',
        'favonius_greatsword',
        'favonius_lance',
        'dragons_bane',
        'wine_and_song',
        'eye_of_perception',
        'sacrificial_fragments',
        'the_widsith',
        'favonius_codex',
        'mitternachts_waltz',
        'alley_hunter',
        'rust',
        'sacrificial_bow',
        'the_stringless',
        'favonius_warbow',
      ],
      version: '4.5',
      timezoneDependent: true,
    },
  ],
};
